"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'None',
  value: 'None'
}, {
  label: 'Daily',
  value: 'Daily'
}, {
  label: 'Weekly',
  value: 'Weekly'
}, {
  label: 'Monthly',
  value: 'Monthly'
}, {
  label: 'Yearly',
  value: 'Yearly'
}, {
  label: 'Custom',
  value: 'Custom'
}];
exports.default = _default;